import Dialog from '@mui/material/Dialog';

import { useSitesInfo } from '@newfold/huapi-js';

import { SitePromoteMutationResponseType } from '~/hooks/usePromoteSiteValidateOnly';
import { SiteInfoType } from '~/types/site';
import { isSiteIdAvailable } from '~/utils/site/helpers';

import PromoteModal from './components/PromoteModal';
import PromoteModalLoading from './components/PromoteModalLoading';
import ResourceLimitErrorModal from './components/ResourceLimitErrorModal';

export type PromoteSitePropsOptions = {
  open: boolean;
  handleClose: Function;
  stagingSite: SiteInfoType;
  sitePromoteResp: SitePromoteMutationResponseType;
};

const PromoteSite = ({
  open,
  handleClose,
  stagingSite,
  sitePromoteResp,
}: PromoteSitePropsOptions) => {
  const { data } = useSitesInfo(Number(stagingSite?.staging?.parent_site_id), {
    query: {
      enabled: isSiteIdAvailable(stagingSite?.staging?.parent_site_id),
    },
  });
  const siteInfo = data?.data;

  const stagingSiteId = stagingSite?.id;

  const { isPending, error } = sitePromoteResp;

  const hasError = error?.response?.data?.error === 'resourceUsageExceeded';

  const limits = error?.response?.data?.details?.limits;

  if (hasError && limits) {
    return (
      <Dialog
        open={open}
        aria-label={'promote resource limit modal'}
        maxWidth={'md'}
        fullWidth
      >
        <ResourceLimitErrorModal
          open={open}
          handleClose={handleClose}
          siteId={stagingSiteId!}
          parentSiteId={stagingSite?.staging?.parent_site_id!}
          limits={limits}
        />
      </Dialog>
    );
  }
  return (
    <>
      {isPending ? (
        <Dialog
          open={open}
          aria-label={'promote loading modal'}
          maxWidth={'sm'}
          fullWidth
        >
          <PromoteModalLoading />
        </Dialog>
      ) : (
        <Dialog
          open={open}
          aria-label={'promote modal'}
          maxWidth={'sm'}
          fullWidth
        >
          <PromoteModal
            open={open}
            handleClose={handleClose}
            parentDomain={siteInfo?.domain!}
            stagingSite={stagingSite}
          />
        </Dialog>
      )}
    </>
  );
};
export default PromoteSite;
